import { Link } from "react-router-dom";
import { Mail, MapPin, Globe } from "lucide-react";

export function Footer() {
  return (
    <footer className="border-t border-slate-800 bg-[#050810] mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="mb-4">
            <img src="/logo.png" alt="SRAM & MRAM Group" className="h-24 w-auto" />
          </div>
          <p className="text-slate-400 text-sm max-w-md leading-relaxed">
            A global conglomerate delivering futuristic technology solutions across healthcare,
            water, enterprise software, infrastructure, resources and hospitality — connecting
            innovation with international markets.
          </p>
          <div className="mt-6 space-y-2 text-sm text-slate-400">
            <p className="flex items-center gap-2"><Mail className="w-4 h-4 text-emerald-400" /> info@srammram.com</p>
            <p className="flex items-center gap-2"><Globe className="w-4 h-4 text-emerald-400" /> Global operations across the Middle East, UK &amp; Europe</p>
            <p className="flex items-center gap-2"><MapPin className="w-4 h-4 text-emerald-400" /> Kuala Lumpur · Dubai · Qatar · UK · India</p>
          </div>
        </div>

        <div>
          <h4 className="eyebrow mb-4">Company</h4>
          <ul className="space-y-2 text-sm text-slate-400">
            <li><Link to="/about" className="hover:text-emerald-400">About Us</Link></li>
            <li><Link to="/verticals" className="hover:text-emerald-400">Verticals</Link></li>
            <li><Link to="/csr" className="hover:text-emerald-400">CSR</Link></li>
            <li><Link to="/careers" className="hover:text-emerald-400">Careers</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="eyebrow mb-4">Resources</h4>
          <ul className="space-y-2 text-sm text-slate-400">
            <li><Link to="/newsroom" className="hover:text-emerald-400">Newsroom</Link></li>
            <li><Link to="/blog" className="hover:text-emerald-400">Blog</Link></li>
            <li><Link to="/contact" className="hover:text-emerald-400">Contact</Link></li>
            <li><Link to="/admin" className="hover:text-emerald-400">Admin</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row justify-between items-center gap-2 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} SRAM &amp; MRAM Group. All rights reserved.</p>
          <p className="font-mono">Futuristic Technology Solutions</p>
        </div>
      </div>
    </footer>
  );
}
